import React from "react";
// import { Box, Button } from "@material-ui/core";
import {
  // AutocompleteInput,
  BooleanInput,
  Edit,
  // ReferenceInput,
  // SelectInput,
  SimpleForm,
  TextInput,
} from "react-admin";
// Local
import {
  //
  // BoolNumInput,
  // NonInput,
  // InputEx,
  TextInputEx,
} from "../../components";
import {
  readonlyInputProps,
  // selectAllTarget
} from "../../lib";
// import {
//   //
//   // FormDataConsumer,
//   sortBy,
//   // useFormState,
// } from "../../react-admin";

function helperTextForGeneratedIfEnabled(values, source) {
  if (!values?.sms?.text && values?.sms?.enabled) {
    return "This will be generated from the email template if left blank.";
  }
  return "";
}

function disabledIfNotEnabled(values) {
  return !values?.sms?.enabled;
}

export const MsgTemplateSmsEdit = props => {
  return (
    <Edit mutationMode="pessimistic" {...props}>
      <SimpleForm redirect={`/msg_templates/${props.id}/show`}>
        <TextInput
          source="name"
          label="Template name"
          fullWidth
          InputProps={readonlyInputProps}
        />
        <BooleanInput
          source="sms.enabled"
          label="SMS enabled"
          defaultValue={false}
        />
        <TextInputEx
          source="sms.text"
          label="Text message"
          autoFocus
          defaultValue=""
          fullWidth
          multiline
          helperText={helperTextForGeneratedIfEnabled}
          disabled={disabledIfNotEnabled}
          // onFocus={selectAllTarget}
        />
      </SimpleForm>
    </Edit>
  );
};
